import { useState, useEffect } from 'react';

import PropTypes from 'prop-types';

import Tabs from '#globalComponents/Tabs/Tabs';

const SCROLL_OFFSET = 64; // px — sticky tab bar height plus breathing room

const CompanyDetailNavigation = ({ sections }) => {
	const [activeSection, setActiveSection] = useState(sections[0]?.id);

	useEffect(() => {
		sections.forEach((section) => {
			const el = document.getElementById(section.id);
			if (el) el.style.scrollMarginTop = `${SCROLL_OFFSET}px`;
		});

		const observer = new IntersectionObserver(
			(entries) => {
				const visible = entries.find((e) => e.isIntersecting);
				if (visible) setActiveSection(visible.target.id);
			},
			{ rootMargin: `-${SCROLL_OFFSET}px 0px -60% 0px`, threshold: 0.1 },
		);

		sections.forEach((section) => {
			const el = document.getElementById(section.id);
			if (el) observer.observe(el);
		});

		return () => observer.disconnect();
	}, [sections]);

	const scrollToSection = (sectionId) => {
		document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
		setActiveSection(sectionId);
	};

	return (
		<div className="sticky top-0 z-10 -mx-4 mb-4 bg-white px-4">
			<Tabs tabs={sections} activeId={activeSection} onChange={scrollToSection} />
		</div>
	);
};

CompanyDetailNavigation.propTypes = {
	sections: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
		}),
	).isRequired,
};

export default CompanyDetailNavigation;
